// Matches WeMod's modal/dialog stacking (currently 1000) with headroom above it. Kept as
// a named constant — not a ds-theme token yet — since no z-index scale exists there today.
export const DEFAULT_TOOLTIP_Z_INDEX = 1002;
